import styled, { css } from 'styled-components';
import { H3, H4 } from '../../font';
import { Paragraph } from '../../typographies';
import { Blue } from '../../../colors';
const flexCenter = css `
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Title = styled(H3) `
    width: 20ch;
    text-align: center;
`;
export const Subtitle = styled(H4) `
    width: 20ch;
    text-align: center;
    color: ${Blue.normal}; 
`;
export const Description = styled(Paragraph) `
    width: 32ch;
    text-align: center;
    margin: 50px 0;
`;
export const Container = styled.div `
    ${flexCenter}
    flex-direction: column;
    height: 80vh;
`;
export const HeaderContainer = styled.div `
    ${flexCenter}
    flex-direction: ${({ reverse }) => reverse ? 'column-reverse' : 'column'};
`;
export const TitleContainer = styled.div `
    ${flexCenter}
    flex-direction: column;
`;
export const Footnote = styled(Paragraph) `
    text-align: center;
    width: 32ch;
    margin: 10px 0;
    span {
        font-size: 13px;
    }
`;
//# sourceMappingURL=StatusScreen.Styled.js.map